module.exports = __webpack_public_path__ + "img/58.8b98a804.png";